import React from "react";
import { BasicError, MuiNavLink } from "../_Misc";
import { useHomeHub } from "../../services/backend";
import makeStyles from "@mui/styles/makeStyles";
import { Scroller } from "./Scroller";
import { PosterCard, PosterCardSkeletonRow } from "../Cards";
import { buildAssetUrl } from "../../utils";
import { generatePath } from "react-router-dom";
import ShowMore from "./ShowMore";
import { links } from "../../constants";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginRight: theme.spacing(4),
    // transition: "all 0.2s ease-in-out",
    // "&:hover": { // need to add padding somewhere to avoid clipping on scale()
    //   transform: "scale(1.05)",
    // },
  },
}));

export const LibraryHub = () => {
  const { data, error, isLoading } = useHomeHub();
  const classes = useStyles();

  if (error) return <BasicError error={error?.message} />;

  if (isLoading)
    return (
      <Scroller title="Recent Library Updates" uid={"_"}>
        <PosterCardSkeletonRow uid="lib" />
      </Scroller>
    );

  if (!data) return <></>;

  const { recent_library_updates } = data;
  if (recent_library_updates.length === 0) return <></>;

  return (
    <div>
      {/* One 'Scroller' row for each library */}
      {recent_library_updates.map((library) => {
        const library_link = generatePath(links.folder, { folder: library.http_path_name });

        return (
          <div key={`HUB_LIBRARY_${library.http_path_name}`}>
            <Scroller
              uid={`library_hub_${library.http_path_name}`}
              title={makeScrollerHeader(library.folder_name, library_link)}
            >
              {/* Each library_item poster card */}
              {library.maps.map((item) => {
                const image_url = buildAssetUrl(
                  item.poster?.cloudinary_path || item.media?.cloudinary_path,
                  "f_auto,h_500,w_333"
                );

                return (
                  <div className={classes.wrapper} key={`HUB_LIBRARY_ITEM_${item.id}`}>
                    <PosterCard
                      alt={"Poster"}
                      link={`/d/item/${item.id}-${item.slug ?? ""}`}
                      title={item.root}
                      image_url={image_url}
                    ></PosterCard>
                  </div>
                );
              })}

              {/* Backend returns max 20 items, so we got 19+ items, there's most likely more, so render "ShowMore" */}
              {library.maps.length > 19 && <ShowMore href={library_link} />}
            </Scroller>
          </div>
        );
      })}
    </div>
  );
};

const makeScrollerHeader = (lib_name: string, link: string) => {
  return (
    <span>
      {"Recently Updated in "}
      <MuiNavLink to={link} underline="hover">
        {lib_name}
      </MuiNavLink>
    </span>
  );
};
